import "angular:locale/data:en-US";
import "./src/polyfills.ts";(globalThis.$localize ??= {}).locale = "en-US";
